import BaseService from './BaseService';
import { camelizeKeys } from 'humps';
import normalize from 'jsonapi-normalizer';
import dates from '@/utils/dates';
import SitesService from '@/services/SitesService';

const objectType = 'landing-rates';

class LandingRatesService extends BaseService {

  static getList(page) {

    return super.get(`landing_rates?page[number]=${page}&page[size]=${this.pageSize()}`)
      .then((response) => {
        const data = normalize(camelizeKeys(response.data));
        _.forEach(Object.keys(data.entities['landing-rates']), (key) => {
          const mosquitoes = [];
          _.forEach(data.entities['landing-rates'][key].landingRateMosquitoes, (mosquito) => {
            mosquitoes.push(data.entities['landing-rate-mosquitoes'][mosquito.id]);
          });
          data.entities['landing-rates'][key].landingRateMosquitoes = mosquitoes;
        });

        const flattenedData = {
          data: [],
          links: response.data.links,
        };
        _.forEach(Object.keys(data.entities['landing-rates']), (key) => {
          flattenedData.data.push({ id: key, type:"landing-rates", attributes: data.entities['landing-rates'][key]})
        });

        return Promise.resolve(flattenedData);
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });

  }

  static siteSearch(search) {
    return SitesService.search(search);
  }

  static search(search, page) {

    return super.get(`landing_rates/search?search[field]=${search.field}&search[term]=${search.term}&page[number]=${page}`)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });

  }

  static getDetails(id) {
    return super.get(`landing_rates/${id}`)
      .then((response) => {
        let object = normalize(response.data);
        let data = object.entities['landing-rates'][object.result['landing-rates'][0]];
        data = camelizeKeys(data);

        data.landingRateMosquitoes = this.getMosquitoes(object);

        return Promise.resolve(data);
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static getMosquitoes(object) {
    const mosquitoes = [];
    _.forEach(object.entities['landing-rate-mosquitoes'], (mosquito) => {
      mosquitoes.push(camelizeKeys(object.entities['landing-rate-mosquitoes'][mosquito.id]));
    });

    return mosquitoes;
  }

  static create(data) {

    data = dates.apiFormat(data, ['observedDate']);

    return super.post(objectType, `landing_rates`, data)
      .then((response) => {
        const data = camelizeKeys(response.data.data);
        data.attributes.landingRateMosquitoes = this.getMosquitoes(normalize(response.data));

        return Promise.resolve(data);
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static update(data) {

    data = dates.apiFormat(data, ['observedDate']);

    return super.patch(objectType, `landing_rates/${data.id}`, data)
      .then((response) => {
        const data = camelizeKeys(response.data.data);
        data.attributes.landingRateMosquitoes = this.getMosquitoes(normalize(response.data));

        return Promise.resolve(data);
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static delete(id) {
    return super.delete(`landing_rates/${id}`)
      .then((response) => {
        return Promise.resolve({id});
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });
  }

}

export default LandingRatesService;